"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPropertyCardPhotoFallback = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var StyledPropertyCardPhotoFallback = /*#__PURE__*/_styledComponents.default.svg.withConfig({
  displayName: "StyledPropertyCardPhotoFallback",
  componentId: "c11n-8-107-0__sc-1rkunlu-0"
})([""]);
exports.StyledPropertyCardPhotoFallback = StyledPropertyCardPhotoFallback;